/* eslint-disable react/prop-types, react-refresh/only-export-components */
import {createContext, useContext, useEffect, useState} from 'react'
import './App.css'
import {Routes, Route, useLocation, useParams, Navigate} from "react-router-dom";
import PropTypes from "prop-types";
import Contact from "./pages/Contact/Contact.jsx";
import About from "./pages/About/About.jsx";
import Customizer from "./pages/Customiz3r/Customizer.jsx";
import FullScreenProvider from "./components/providers/FullScreenProvider.jsx";
import ThemeProvider from "./components/providers/ThemeProvider.jsx";
import Login from "./pages/Login/Login.jsx";
import Register from "./pages/Register/Register.jsx";
import ForgotPassword from "./pages/ForgotPassword/ForgotPassword.jsx";
import ResetPassword from "./pages/ResetPassword/ResetPassword.jsx";
import VerifyEmail from "./pages/VerifyEmail/VerifyEmail.jsx";
import Pruebas from "./pages/Pruebas/Pruebas.jsx";
import AuthProvider from "./components/providers/AuthProvider.jsx";
import Profile from "./pages/Profile/Profile2.jsx";
import RequireAuth from "./components/auth/RequireAuth.jsx";
import RequireCustomizer from "./components/auth/RequireCustomizer.jsx";
import SelectedTypeProvider from "./pages/Customiz3r/SelectedTypeProvider.jsx";
import {getProduct, routeTransitionKey} from "./products/registry";
import DataProvider from "./pages/Customiz3r/DataProvider.jsx";
import {DeviceProvider} from "./components/providers/DeviceProvider.jsx";
import Mi3DViewer from "./pages/Profile/pages/MisProyectos/Mi3DViewer/Mi3DViewer.jsx";
import HomeNavBar from "./components/HomeNavbar/HomeNavBar.jsx";
import ProductsView from "./pages/Store/ProductsView.jsx";
import "/src/components/tools/ScrollbarMod.css";
import ProductDetail2 from "./pages/Store/ProductDetail/ProductDetail2.jsx";
import {CartProvider} from "./components/providers/CartProvider.jsx";
import CartPage from "./pages/Store/Cart/CartPage.jsx";
import CheckoutPage from "./pages/Store/Checkout/CheckoutPage.jsx";
import CheckoutSuccessPage from "./pages/Store/Checkout/CheckoutSuccessPage.jsx";
import PurchaseLinkPage from "./pages/Store/PurchaseLink/PurchaseLinkPage.jsx";
import HomePage from "./pages/HomePage/HomePage.jsx";
import DesignSystem from "./pages/DesignSystem/DesignSystem.jsx";
import HomeBackground from "./components/HomeBackground/HomeBackground.jsx";
import { isWebGLAvailable } from "./components/HomeBackground/systems/renderer.js";
import SilentErrorBoundary from "./components/ErrorBoundary/SilentErrorBoundary.jsx";
import {ToastContainer} from "react-toastify";
import Public3dViewer from "./pages/Public3dViewer/Public3dViewer.jsx";
import PublicCatalog, { PublicCatalogModel } from "./pages/PublicCatalog/PublicCatalog.jsx";
import { MiProyectoModelo } from "./pages/Profile/pages/ProyectosCliente/ProyectosCliente.jsx";
import BubbleConfigurator from "./pages/BubbleConfigurator/BubbleConfigurator.jsx";
import Admin2 from "./pages/Admin/Admin2.jsx";
import {AnimatePresence} from "framer-motion";
import { MenuProvider } from "./pages/Admin/MenuContext.jsx"; // Importar MenuProvider
import CustomizerSelector from "./pages/CustomizerSelector/CustomizerSelector.jsx";
import NfcGuide from "./pages/NfcGuide/NfcGuide.jsx";

/*************** Context Editor *****************/
const EditorContext = createContext();

const EditorProvider = ({ children }) => {
    const [stateEditor, setStateEditor] = useState();

    return (
        <EditorContext.Provider value={{ stateEditor, setStateEditor }}>
            {children}
        </EditorContext.Provider>
    );
};

export const useEditor = () => useContext(EditorContext);
/*************** Fin Context Editor *****************/

/**
 * One editor, one route per product type.
 *
 * A route rather than a query param because `modelId` being absent already means
 * "new" inside Customizer, so `/lightbox` is a new lightbox with no extra logic,
 * and because each product wants its own deep links. If the loaded model turns
 * out to belong to another product, Customizer redirects to the right route —
 * what was saved wins over the URL.
 */
/**
 * Redirección desde las URLs anteriores al renombrado (`/customiz3r`,
 * `/lightbox`) hacia la `routeBase` actual del producto, conservando el id.
 * `replace` para no dejar la URL vieja en el historial.
 */
const LegacyEditorRedirect = ({ productType }) => {
    const { modelId } = useParams();
    const { routeBase } = getProduct(productType);
    return <Navigate to={modelId ? `${routeBase}/${modelId}/` : routeBase} replace/>;
};

LegacyEditorRedirect.propTypes = {
    productType: PropTypes.string.isRequired,
};

const ProductEditorRoute = ({ productType }) => (
    <RequireAuth>
        <RequireCustomizer productType={productType}>
            <DataProvider productType={productType}>
                <SelectedTypeProvider>
                    <Customizer productType={productType}/>
                </SelectedTypeProvider>
            </DataProvider>
        </RequireCustomizer>
    </RequireAuth>
);

function App() {
    const location = useLocation();
    // Sin WebGL (GPU bloqueada en el navegador) el fondo 3D no se monta;
    // el boundary cubre fallos posteriores para no tumbar toda la app.
    const [webglAvailable] = useState(isWebGLAvailable);

    useEffect(() => {
        // console.log("App component rendered with location:", location.pathname[1]);
    }, [location]);

    return (
        <ThemeProvider>
            <CartProvider >
                <FullScreenProvider>
                    <DeviceProvider>
                        <AuthProvider>
                            <MenuProvider> {/* Envolver con MenuProvider */}
                                    <div className='background-app'>
                                    </div>
                                    <div className="layer_toastify">
                                        <ToastContainer/>
                                    </div>
                                    <div className={`App`}>
                                        <div className='navbarApp '>
                                            <HomeNavBar/>
                                        </div>

                                        <EditorProvider>
                                            <div id="containerApp" className="containerApp overflow-y-hidden  w-screen"
                                                 style={{"scrollSnapType": "y mandatory"}}
                                            >
                                                <AnimatePresence mode={"wait"}>
                                                {/* La clave marca qué es "otra
                                                    página" para la transición.
                                                    Por pathname, crear un diseño
                                                    (/customiz3r_keyring → …/12)
                                                    remontaba el editor entero: se
                                                    perdía la vista 3D y el lienzo
                                                    se recargaba. Las rutas de un
                                                    mismo editor comparten clave. */}
                                                <Routes location={location} key={routeTransitionKey(location.pathname)}>
                                                    <Route index element={<HomePage/>}/>
                                                    <Route path="/about" element={<About/>}/>
                                                    <Route path="/guia-nfc" element={<NfcGuide/>}/>
                                                    <Route path="/contact" element={<Contact/>}/>
                                                    <Route path="/customizers" element={
                                                        <RequireAuth>
                                                            <CustomizerSelector/>
                                                        </RequireAuth>
                                                    }/>
                                                    <Route path="/customiz3r_keyring/:modelId?" element={
                                                        <ProductEditorRoute productType="keyring"/>}
                                                    />
                                                    <Route path="/customiz3r_lightbox/:modelId?" element={
                                                        <ProductEditorRoute productType="lightbox"/>}
                                                    />
                                                    <Route path="/customiz3r_servilletero_panel/:modelId?" element={
                                                        <ProductEditorRoute productType="napkin_panel"/>}
                                                    />
                                                    {/* Paramétrico, sin lienzo 2D: página propia, no el Customizer. */}
                                                    <Route path="/customiz3r_servilletero/:modelId?" element={
                                                        <RequireAuth>
                                                            <RequireCustomizer productType="napkin_bubble">
                                                                <BubbleConfigurator/>
                                                            </RequireCustomizer>
                                                        </RequireAuth>}
                                                    />
                                                    {/* Rutas anteriores al renombrado. Siguen vivas en
                                                        marcadores y en correos ya enviados (el email de
                                                        bienvenida y los enlaces de pedidos apuntaban a
                                                        /customiz3r), así que redirigen en vez de dar 404. */}
                                                    <Route path="/customiz3r/:modelId?"
                                                           element={<LegacyEditorRedirect productType="keyring"/>}/>
                                                    <Route path="/lightbox/:modelId?"
                                                           element={<LegacyEditorRedirect productType="lightbox"/>}/>
                                                    <Route path="/login" element={<Login/>} />
                                                    <Route path="/register" element={<Register/>} />
                                                    <Route path="/forgot-password" element={<ForgotPassword/>} />
                                                    <Route path="/reset-password" element={<ResetPassword/>} />
                                                    <Route path="/verify-email" element={<VerifyEmail/>} />
                                                    <Route path="/pruebas" element={<Pruebas/>} />
                                    <Route path="/design-system" element={<DesignSystem/>} />
                                                    <Route path="/profile/*" element={
                                                        <RequireAuth>
                                                            <Profile/>
                                                        </RequireAuth>
                                                    } />
                                                    <Route path="/admin/*" element={
                                                        <RequireAuth>
                                                            <Admin2/>
                                                        </RequireAuth>
                                                    } />
                                                    <Route path="/store" element={<ProductsView/>} />
                                                    <Route path="/product/:id" element={<ProductDetail2 />} />
                                                    <Route path="/viewer/:modelId?" element={
                                                        <RequireAuth>
                                                            <Mi3DViewer/>
                                                        </RequireAuth>
                                                    }/>
                                                    <Route path="/public-viewer/:token" element={<Public3dViewer />} />
                                                    <Route path="/catalogo/:token" element={<PublicCatalog />} />
                                                    <Route path="/catalogo/:token/modelo/:itemId" element={<PublicCatalogModel />} />
                                                    <Route path="/mis-proyectos/:projectId/modelo/:itemId" element={
                                                        <RequireAuth>
                                                            <MiProyectoModelo/>
                                                        </RequireAuth>
                                                    } />
                                                    <Route path="/comprar/:token" element={<PurchaseLinkPage />} />
                                                    <Route path="/cart" element={<CartPage />} />
                                                    <Route path="/checkout" element={
                                                        <RequireAuth>
                                                            <CheckoutPage />
                                                        </RequireAuth>
                                                    } />
                                                    <Route path="/checkout/success/:orderNumber" element={
                                                        <RequireAuth>
                                                            <CheckoutSuccessPage />
                                                        </RequireAuth>
                                                    } />
                                                </Routes>
                                                </AnimatePresence>
                                                {webglAvailable && (
                                                    <SilentErrorBoundary>
                                                        <HomeBackground />
                                                    </SilentErrorBoundary>
                                                )}
                                            </div>
                                        </EditorProvider>
                                    </div>
                            </MenuProvider> {/* Cerrar MenuProvider */}
                        </AuthProvider>
                    </DeviceProvider>
                </FullScreenProvider>
            </CartProvider>
        </ThemeProvider>
    )
}

export default App
